<template>
    <form-row title="Have you received your Closing Disclosure?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="have_received_closing"
                v-model="have_received_closing"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="have_received_closing"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Received:"
                :value="closing.have_received_closing_date"
                name="have_received_closing_date"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        closing: {},
        read_only: { default: false },
    },

    data() {
        return {
            have_received_closing: this.closing.have_received_closing,
        }
    },
}
</script>
